var searchSuggester = {
	inputPlaceholder: "Recherche",
	clearSearchTerm: "Effacer le terme de la recherche",
	noResults: "Aucun résultat trouvé",
	allSearchResults: "Tous les résultats de la recherche",
	validationErrors: {
		searchTerm: {
			invalidInput: "Entrée non valide"
		}
	}
};
var searchSuggesterTranslationsFr = {
	searchSuggester: searchSuggester
};

export { searchSuggesterTranslationsFr as default, searchSuggester };
